module.exports = __webpack_public_path__ + "static/img/1_3_1.6341c864.jpg";